import type { NestedFilter, CommonSort } from '@@partner:types:graphql'

import React, { useState, useCallback } from 'react'
import { useParams, Link, generatePath } from 'react-router-dom'

import { Button, Message, Pagination, Panel } from 'rsuite'
import PeopleSpeaker from '@rsuite/icons/legacy/PeopleGroup'

import { ORDERS_PER_PAGE_LIMIT } from '@@partner:config/index'
import { ROUTE_CUSTOMERS, ROUTE_MODERATE_BUSINESS_PROFILES } from '@@partner:config/routes'
import { useFetchAllBusinessProfiles } from '@@partner:graphql/query/businessProfiles/allBusinessProfiles.gql'
import BusinessProfilesTable from '@components/businessProfiles/grid/BusinessProfilesTable'
import { convertToInt } from '@@partner:helpers/util'
import BusinessProfilesFilter from '@components/businessProfiles/grid/BusinessProfilesFilter'
import CustomersTopMenu from '@components/customers/CustomersTopMenu'

export default function BusinessProfilesPage () {
  const { brandSlug } = useParams<any>()

  const [ page, setPage ] = useState(1)
  const [ filter, setFilter ] = useState<NestedFilter>({
    fields: [ 'id' ],
    op: 'unwrap'
  })
  const [ sort, setSort ] = useState<CommonSort>({
    fieldName: 'id',
    direction: 0
  })

  const { data, loading, error } = useFetchAllBusinessProfiles({
    pager: {
      page,
      limit: ORDERS_PER_PAGE_LIMIT
    },
    filter,
    sort
  })

  const handlePageSelect = useCallback((selectedPage: string | number) => {
    setPage(convertToInt(selectedPage))
  }, [])

  const handleSortColumn = useCallback((sortColumn, sortType) => {
    setSort({
      fieldName: sortColumn,
      direction: sortType === 'desc' ? 0 : 1
    })
  }, [])

  const handleFilterChanged = useCallback(
    (updatedFilter: NestedFilter) => {
      setFilter(updatedFilter)
      handlePageSelect(1)
    },
    [ handlePageSelect ]
  )

  const allBusinessProfiles = data?.allBusinessProfiles?.edges ?? []
  const pageInfo = data?.allBusinessProfiles?.pageInfo

  const showPagination = pageInfo?.lastPage !== 1

  return (
    <div className="CustomersPage">
      <h1 className="u-heading">Компании</h1>
      {error && (
        <Message
          showIcon
          type="error"
          header="При получении данных возникла ошибка!"
        >
          {error.message}
        </Message>
      )}
      <CustomersTopMenu />


      <BusinessProfilesFilter onFilterChanged={handleFilterChanged} />

      <Panel shaded>
        {allBusinessProfiles && (
          <BusinessProfilesTable
            brandSlug={brandSlug}
            businessProfiles={allBusinessProfiles}
            loading={loading}
            onSortColumn={handleSortColumn}
            sortColumn={sort.fieldName}
            sortType={sort.direction === 0 ? 'desc' : 'asc'}
          />
        )}

        {showPagination && (
          <Pagination
            size="md"
            last
            first
            next
            prev
            ellipsis
            activePage={page}
            pages={pageInfo?.lastPage}
            total={pageInfo?.lastPage ?? 1}
            maxButtons={10}
            onSelect={handlePageSelect}
          />
        )}
      </Panel>
    </div>
  )
}
